import { render, staticRenderFns } from "./AccountsListDetailPage.vue?vue&type=template&id=8cecd43e&"
import script from "./AccountsListDetailPage.vue?vue&type=script&lang=js&"
export * from "./AccountsListDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cecd43e')) {
      api.createRecord('8cecd43e', component.options)
    } else {
      api.reload('8cecd43e', component.options)
    }
    module.hot.accept("./AccountsListDetailPage.vue?vue&type=template&id=8cecd43e&", function () {
      api.rerender('8cecd43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AccountsListDetailPage.vue"
export default component.exports